import { Primitive } from '../../../../types/blocks/Primitive';

/**
 * @deprecated use PropertyInputBlock instead
 */
export const NumberInputBlock: Primitive = {
  name: 'NumberInputBlock',
  isInput: true,
  isPrimitive: true,
  properties: {
    number: {
      type: 'Number',
    },
    disabled: {
      type: 'Boolean',
      default: false,
    },
    min: {
      type: 'Number',
      validators: [
        {
          name: 'Min',
          value: -(2 ** 32),
        },
        {
          name: 'Max',
          value: 2 ** 32,
        },
      ],
    },
    max: {
      type: 'Number',
      validators: [
        {
          name: 'Min',
          value: -(2 ** 32),
        },
        {
          name: 'Max',
          value: 2 ** 32,
        },
      ],
    },
    step: {
      type: 'Number',
      validators: [
        {
          name: 'Min',
          value: -(2 ** 32),
        },
        {
          name: 'Max',
          value: 2 ** 32,
        },
      ],
    },
    placeholder: {
      type: 'String',
      validators: [
        {
          name: 'Max',
          value: 2048,
        },
      ],
    },
  },
  publishes: {
    // @ts-expect-error ts-migrate(2741) FIXME: Property 'action' is missing in type '{ type: "Eve... Remove this comment to see the full error message
    input: {
      type: 'Event',
    },
    // @ts-expect-error ts-migrate(2741) FIXME: Property 'action' is missing in type '{ type: "Eve... Remove this comment to see the full error message
    click: {
      type: 'Event',
    },
  },
};
